<app-breadcrumb [master]="masterModule ? masterModule : 'Struktura sieci'" [parentName]="'Dokumenty'" [name]="'Lista'"></app-breadcrumb>
<div class="document-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="document-list-filters">
    <mat-form-field class="document-list-filter">
      <mat-label>Nazwa</mat-label>
      <input matInput placeholder="Plik.pdf" name="contains$filename" [(ngModel)]="initialFilters.contains$filename">
    </mat-form-field>

    <app-dict
      [multiple]="false" [dictType]="'file_type'"
      [label]="'Typ'" class="document-list-filter"
      [(ngModel)]="initialFilters.type" name="type"
      [skipKeys]="[FILE_TYPE_ALLIANZ_CERT, FILE_TYPE_ALLIANZ_CERT_MY_CAR, FILE_TYPE_ALLIANZ_CERT_DOCUMENTS, FILE_TYPE_ALLIANZ_CERT_FRAUDS]"
    ></app-dict>

    <app-datepicker
      class="document-list-filter"
      label="Data dodania od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="document-list-filter"
      label="Data dodania do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <mat-form-field class="document-list-filter">
      <mat-label>Użytkownik</mat-label>
      <input matInput placeholder="JanKow123" name="username" [(ngModel)]="initialFilters.username">
    </mat-form-field>

    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="document-list-filter document-list-filter-long"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="document-list-filter document-list-filter-long"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <app-dict
      [multiple]="false" [dictType]="'contract_type'"
      [label]="'Typ umowy'" class="document-list-filter"
      [(ngModel)]="initialFilters.contractType" name="contractType"
    ></app-dict>

    <app-dict-insurance-companies
      class="document-list-filter" [multiple]="true" label="TU"
      [required]="false"
      [(ngModel)]="initialFilters.in$insuranceCompany" name="in$insuranceCompany"
    ></app-dict-insurance-companies>

    <mat-form-field appearance="standard" class="document-list-filter" *ngIf="(userPermissions | async).document.admin_root">
      <mat-label>Archiwum</mat-label>
      <mat-select [(ngModel)]="initialFilters.archived" name="archived">
        <mat-option [value]="null">Wyczyść</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <div class="document-list-buttons">
    <button *ngIf="(userPermissions | async).document.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).document.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="documents">

    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa</th>
      <td mat-cell *matCellDef="let element">
        <div class="statusChange-flex-container">
        <a *ngIf=!controlTest() class="default-link" [routerLink]="['/dokumenty/szczegoly', element.uuid]">{{element.documentName ? element.documentName : element.filename}}</a>

        <a *ngIf=controlTest() class="default-link" [routerLink]="['/dokumenty/rejestracje/szczegoly', element.uuid]">{{element.documentName ? element.documentName : element.filename}}</a>
        <mat-chip-list *ngIf="element.deleted">
          <mat-chip class="deletet-chips" color="accent" selected matTooltip="Archiwum">A</mat-chip>
        </mat-chip-list>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Typ</th>
      <td mat-cell *matCellDef="let element">
        {{element.type?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data dodania </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="updatedAt">
      <th mat-header-cell *matHeaderCellDef> Data modyfikacji </th>
      <td mat-cell *matCellDef="let element">
        {{element.updatedAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        {{element.user?.username }}
      </td>
    </ng-container>

    <ng-container matColumnDef="partnerOrOfwca">
      <th mat-header-cell *matHeaderCellDef> Partner/OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner">
          Partner: <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
        </ng-container>

        <ng-container *ngIf="element.ofwca">
          OFWCA: <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca.fullName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="contractType">
      <th mat-header-cell *matHeaderCellDef> Typ umowy</th>
      <td mat-cell *matCellDef="let element">
        {{element.contract?.type?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany?.id]">
          {{element.insuranceCompany?.name}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="product">
      <th mat-header-cell *matHeaderCellDef> Nagroda </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.competitionImportRow" class="default-link" [routerLink]="['/stan-magazynowy/szczegoly', element.competitionImportRow?.warehouseProduct?.uuid]">
          {{element.competitionImportRow?.warehouseProduct?.productName }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button (click)="openDocument(element)"
                mat-icon-button color="primary"><mat-icon>visibility</mat-icon></button>
        <button mat-icon-button color="accent" aria-label="" (click)="downloadFile(element.uuid)">
          <mat-icon>download</mat-icon>
        </button>
        <button [disabled]="!(userPermissions | async).document.delete" color="warn" mat-icon-button (click)="deleteDocument(element)"><mat-icon>delete</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
